// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconRmsZenConnectImageRenderer_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12.6341 1.77112C12.7188 2.50638 12.3935 3.19439 11.8394 3.60642L12.1047 5.90768C13.021 6.01994 13.8415 6.44201 14.4582 7.06592L16.9209 5.02867C16.8058 4.34726 17.0474 3.62477 17.6181 3.15261C18.4692 2.44855 19.7299 2.56774 20.434 3.41884C21.1381 4.26994 21.0189 5.53065 20.1678 6.23471C19.5977 6.70628 18.8439 6.80853 18.1967 6.5689L15.4726 8.82239C15.5643 9.15861 15.6133 9.51248 15.6133 9.87779C15.6133 10.66 15.3888 11.3898 15.0006 12.0062L17.9043 15H15.1182L13.5471 13.3801C12.9739 13.6973 12.3147 13.8778 11.6133 13.8778C10.8556 13.8778 10.1471 13.6671 9.54318 13.3012L4.40016 17.6866C4.5251 18.366 4.29426 19.0916 3.73083 19.5721C2.89034 20.2887 1.62799 20.1884 0.911305 19.3479C0.194617 18.5074 0.294982 17.245 1.13548 16.5284C1.69865 16.0481 2.45121 15.9348 3.10212 16.165L8.14234 11.8673C7.80575 11.2813 7.61328 10.602 7.61328 9.87779L7.61338 9.84925L3.47807 8.74113C2.9893 9.22941 2.26066 9.45084 1.54533 9.25919C0.478436 8.9733 -0.154743 7.87662 0.131146 6.80973C0.417035 5.74283 1.51371 5.10978 2.58061 5.39567C3.29545 5.58707 3.81559 6.14249 3.99504 6.80924L8.1265 7.91616C8.5707 7.1283 9.2742 6.5061 10.1212 6.16536L9.85264 3.83593C9.21896 3.56094 8.74519 2.96482 8.66039 2.22925C8.53388 1.13195 9.32086 0.139856 10.4182 0.0133475C11.5155 -0.113161 12.5076 0.673822 12.6341 1.77112ZM13.6133 9.87779C13.6133 10.9824 12.7179 11.8778 11.6133 11.8778C10.5087 11.8778 9.61328 10.9824 9.61328 9.87779C9.61328 8.77322 10.5087 7.87779 11.6133 7.87779C12.7179 7.87779 13.6133 8.77322 13.6133 9.87779Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M14 16H24V24H14V16ZM22 20L20 22L18 19L16 22V18H22V20Z" class="svg-bg"/>
</svg>
`;
/**
 * IconRmsZenConnectImageRenderer is a generated icon component.
 */
let IconRmsZenConnectImageRenderer = IconRmsZenConnectImageRenderer_1 = class IconRmsZenConnectImageRenderer extends IconBaseElement {
    render() {
        return html `${IconRmsZenConnectImageRenderer_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconRmsZenConnectImageRenderer.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconRmsZenConnectImageRenderer = IconRmsZenConnectImageRenderer_1 = __decorate([
    customElement('zui-icon-rms-zen-connect-image-renderer')
], IconRmsZenConnectImageRenderer);
export { IconRmsZenConnectImageRenderer };
